// extracted by mini-css-extract-plugin
export var notificationHost = "_dm-0";